import React, { useState } from 'react'
import { Grid, Button, Modal, Box, Typography } from '@mui/material'
import { TextBold, TextRegular } from '../../../../commonComponents/TextStyling'
import serverData from '../../../../api/ServerData'
import moment from 'moment'
import AppButton from '../../../../commonComponents/AppButton'
import CloseIcon from '@mui/icons-material/Close'
import { colorWithOpacity, showToast } from '../../../../utils/AppHelper'
import { useTheme } from '@mui/styles'
import ResendRTRmailModal from './ResendRTRmailModal'
import NeedHelpModal from './NeedHelpModal'
import CandidateFormModal from '../CandidateFormModal'
import ViewApplicationModal from './ViewApplicationModal'
import ChatBox from './ChatBox'
import { logoutUser } from '../../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ENV } from '../../../../ENV'

export default function CandidateItem ({ item, onReload, matches }) {
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const [previewChatBot, setPreviewChatBot] = useState({
    open: false
  })

  const [previewModal, setPreviewModal] = useState({
    open: false
  })
  const [previewRTRModal, setPreviewRTRModal] = useState({
    open: false
  })
  const [previewEditCandidateModal, setPreviewEditCandidateModal] = useState({
    open: false
  })
  const [previewApplicationModal, setPreviewApplicationModal] = useState({
    open: false
  })
  const handleGetStatusText = (status, subStatus) => {
    switch (status) {
      case 'pendingAtCandidate':
        return 'Approval is pending at candidate.'
      case 'pendingAtManager':
        return `Approval is pending at ${ENV.product_name} manager.`
      case 'pendingAtEmployer':
        return 'Approval is pending at employer.'
      case 'hired':
        return 'Candidate is hired.'
      case 'rejected':
        return 'Candidate is rejected.'
      case 'closed':
        return 'Application has been closed.'
      case 'underConsideration':
        switch (subStatus) {
          case 'managerReview':
            return 'Application is at manager review.'
          case 'interviewStage':
            return 'Application is in interview stage'
          case 'offerStage':
            return 'Application is in offer stage'
          default:
            return ''
        }
      default:
        return ''
    }
  }
  const handleRTREmail = () => {
    setLoading(true)
    serverData.resentCandidateRTRmail(
      { applicationId: item?.applicationId },
      data => {
        if (data.status) {
          setPreviewRTRModal({
            open: true,
            item,
            onClose: () => {
              setPreviewRTRModal({
                open: false
              })
            }
          })
        } else {
          showToast(data.message)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  var items = [
    {
      label: 'Application status',
      value: handleGetStatusText(item?.status, item?.subStatus),
      needHelp: true
    },
    {
      label: 'Applied on',
      value: moment(item?.createdAt).format('D MMMM YYYY, dddd')
    },
    { label: 'Job position', value: item?.jobTitle },
    {
      label: 'Employer',
      value: item?.companyname,
      color: theme.palette.primary.main
    },
    {
      label: 'Job Status',
      value: item?.jobStatus.toUpperCase(),
      color: item?.jobStatus === 'active' ? theme.palette.text.success : null
    }
  ]

  var stages = []
  if (item.managerReviewDate) {
    stages.push({
      label: 'Manager review date',
      value: moment(item.managerReviewDate).format('D MMMM YYYY, dddd')
    })
  }

  if (item.interviewStageDate) {
    stages.push({
      label: 'Interview date',
      value: moment(item.interviewStageDate).format('D MMMM YYYY, dddd')
    })
  }

  if (item.offerStageDate) {
    stages.push({
      label: 'Offer date',
      value: moment(item.offerStageDate).format('D MMMM YYYY, dddd')
    })
  }

  if (item.rejectedOnDate) {
    stages.push({
      label: 'Rejected on',
      value: moment(item.rejectedOnDate).format('D MMMM YYYY, dddd')
    })
  }
  if (stages.length > 0) {
    items.splice(2, 0, ...stages)
  }

  if (item.closeReason) {
    items.splice(1, 0, { label: 'Close reason', value: item?.closeReason })
  }

  return (
    <Grid
      container
      style={{
        marginTop: '32px',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '16px',
        padding: '24px'
      }}
    >
      {!item.isRegistered && matches && (
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'right' }}
        >
          <div
            style={{
              marginTop: '-24px',
              marginRight: '-24px',
              background: 'red',
              width: '10rem',
              display: 'flex',
              justifyContent: 'center',
              borderBottomLeftRadius: '16px',
              borderTopRightRadius: '16px',
              padding: '4px',
              // border: `1px solid ${theme.palette.primary.main}`,
              backgroundColor: colorWithOpacity(theme.palette.primary.main, 0.1)
            }}
          >
            <TextRegular
              style={{
                fontStyle: 'italic',
                color: theme.palette.text.error
              }}
            >
              (Unregistered)
            </TextRegular>
          </div>
        </div>
      )}
      <Grid item xs={matches ? 12 : 6.5} style={{ padding: '10px' }}>
        <Grid container direction={'row'}>
          <Grid item xs={12}>
            <Grid container direction={'row'} alignItems={'center'}>
              <Grid
                item
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  border: `1px solid ${theme.palette.border.main}`,
                  width: matches ? '55px' : '89px',
                  height: matches ? '55px' : '88px',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  padding: '8px',
                  alignItems: 'center'
                }}
              >
                <TextRegular
                  style={{
                    fontSize: matches ? '24px' : '32px'
                  }}
                >
                  {item?.candidateFirstName.substring(0, 1).toUpperCase()}
                  {item?.candidateLastName.substring(0, 1).toUpperCase()}
                </TextRegular>
              </Grid>
              <Grid item xs={9}>
                <Grid container style={{ paddingLeft: '16px' }}>
                  <Grid
                    item
                    xs={12}
                    style={{ marginBottom: matches ? '2px' : 8 }}
                  >
                    <TextBold
                      style={{
                        fontSize: matches ? '16px' : '18px'
                      }}
                    >
                      {item?.candidateFirstName} {item?.candidateLastName}
                    </TextBold>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: 4 }}>
                    <TextRegular
                      style={{
                        fontSize: matches ? '14px' : '16px',
                        color: theme.palette.text.secondary
                      }}
                    >
                      {item?.candidateEmail}
                    </TextRegular>
                    {!item.isRegistered && !matches && (
                      <TextRegular
                        style={{
                          fontStyle: 'italic',
                          fontSize: matches ? '14px' : '16px',
                          color: theme.palette.text.secondary,
                          marginLeft: 4
                        }}
                      >
                        (Unregistered)
                      </TextRegular>
                    )}
                  </Grid>
                  <Grid item xs={12} style={{ padding: '0px' }}>
                    <TextRegular
                      style={{
                        fontSize: matches ? '14px' : '16px',
                        color: theme.palette.text.secondary
                      }}
                    >
                      {item?.candidatePhone}
                    </TextRegular>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ padding: '24px 0px' }}>
            <Grid container spacing={2}>
              {item?.status === 'pendingAtCandidate' && (
                <Grid item>
                  <AppButton
                    name={'Edit Application'}
                    onClick={() => {
                      setPreviewEditCandidateModal({
                        open: true,
                        item: { ...item },
                        isEdit: true,
                        onClose: isReload => {
                          if (isReload === true) {
                            onReload()
                          }
                          setPreviewEditCandidateModal({
                            open: false,
                            item: null
                          })
                        }
                      })
                    }}
                  />
                </Grid>
              )}
              <Grid item>
                {item?.status === 'pendingAtCandidate' ? (
                  <>
                    <AppButton
                      variant='contained'
                      style={{ textTransform: 'none' }}
                      onClick={() => {
                        handleRTREmail()
                      }}
                      name='Resend RTR Email'
                      disabled={false}
                      loading={loading}
                    />
                  </>
                ) : (
                  <>
                    <Button
                      variant='outlined'
                      style={{ textTransform: 'none' }}
                      onClick={() => {
                        setPreviewApplicationModal({
                          open: true,
                          item: { ...item },
                          isEdit: true,
                          onClose: () => {
                            setPreviewApplicationModal({
                              open: false,
                              item: null
                            })
                          }
                        })
                      }}
                    >
                      View Application
                    </Button>
                  </>
                )}
              </Grid>
              {matches && (
                <Grid item>
                  <AppButton
                    variant='contained'
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      setPreviewChatBot({
                        open: true,
                        item,
                        onClose: () => {
                          setPreviewChatBot({
                            open: false
                          })
                        }
                      })
                    }}
                    name='Open Chat Box'
                    disabled={false}
                    loading={loading}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          {!matches && (
            <Grid
              item
              xs={12}
              style={{
                paddingBottom: '16px',
                maxHeight: '30vh',
                overflowY: 'auto'
              }}
            >
              <ChatBox item={item} matches={matches} />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={matches ? 12 : 5.5}>
        <Grid container>
          {items.map((row, index) => (
            <Grid
              container
              style={{
                backgroundColor:
                  index % 2 !== 0
                    ? theme.palette.background.paper
                    : theme.palette.background.default,
                padding: '8px 16px'
              }}
            >
              <Grid item xs={4}>
                <TextBold style={{ fontSize: matches ? '14px' : '16px' }}>
                  {row.label} :
                </TextBold>
              </Grid>
              <Grid
                item
                xs={8}
                style={{
                  textAlign: 'end'
                }}
              >
                <TextRegular
                  style={{
                    fontSize: matches ? '14px' : '16px',
                    color: row.color
                  }}
                >
                  {row.value}
                  {row.needHelp && item?.status === 'pendingAtCandidate' ? (
                    <span
                      onClick={() => {
                        setPreviewModal({
                          open: true,
                          item,
                          onClose: () => {
                            setPreviewModal({
                              open: false
                            })
                          }
                        })
                      }}
                      style={{
                        color: theme.palette.primary.main,
                        cursor: 'pointer',
                        fontSize: matches ? '14px' : '16px',
                        marginLeft: 4
                      }}
                    >
                      Need help?
                    </span>
                  ) : null}
                </TextRegular>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {previewChatBot?.open && (
        <OpenChatBox data={previewChatBot} matches={matches} />
      )}
      {previewRTRModal?.open && <ResendRTRmailModal data={previewRTRModal} />}
      {previewModal?.open && (
        <NeedHelpModal
          data={previewModal}
          handleRTREmail={handleRTREmail}
          loading={loading}
        />
      )}
      {previewEditCandidateModal?.open && (
        <CandidateFormModal
          data={previewEditCandidateModal}
          matches={matches}
        />
      )}
      {previewApplicationModal?.open && (
        <ViewApplicationModal
          data={previewApplicationModal}
          matches={matches}
        />
      )}
    </Grid>
  )
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2,
  width: '85%',
  maxHeight: '60%',
  overflowY: 'auto'
}

function OpenChatBox ({ data, matches }) {
  var { open, item, onClose } = data
  const theme = useTheme()
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <CloseIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 4,
            top: 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <ChatBox item={item} matches={matches} />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
